import { Link } from 'react-router-dom';

export default function SEOTextSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <article>
          <p className="text-xs uppercase tracking-[0.2em] text-primary-600 mb-3 font-[family-name:var(--font-label)]">
            OOPBuy Spreadsheet Wissen
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-8">
            Was ist das OOPBuy Spreadsheet?
          </h2>

          <div className="prose-custom space-y-6 text-sm md:text-base text-foreground-700 leading-relaxed font-[family-name:var(--font-body)]">
            <p>
              Das <strong>OOPBuy Spreadsheet</strong> ist ein innovatives Tool, das speziell für den 
              deutschen Markt entwickelt wurde. Es vereinfacht den gesamten Bestellprozess für Mode, 
              Sneaker und Accessoires aus internationalen Quellen und bietet eine zentrale Übersicht 
              über alle verfügbaren Produktkategorien. Mit dem OOPBuy Spreadsheet behältst du stets 
              den Überblick über Preise, Versandoptionen und Qualitätskontrollen.
            </p>

            <p>
              Unser <strong>Spreadsheet Deutschland</strong> Service umfasst mehr als 14 sorgfältig 
              kuratierte Produktkategorien - von <strong>Shoes</strong> über <strong>Hoodies und Sweaters</strong> 
              bis hin zu <strong>Accessories</strong> und <strong>Parfums</strong>. Jede Kategorie wird 
              regelmäßig aktualisiert und mit den neuesten Angeboten befüllt. Besonders beliebt sind 
              unsere Kategorien für Sneaker und Designerkleidung, die monatlich tausende Besucher 
              anziehen.
            </p>

            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 mt-10 mb-4">
              Warum unser OOPBuy Spreadsheet?
            </h3>

            <p>
              Anders als andere <strong>Spreadsheet</strong> Anbieter konzentrieren wir uns ausschließlich 
              auf den deutschsprachigen Raum. Das bedeutet: Alle Versandinformationen sind auf Deutschland 
              zugeschnitten, Zollgebühren werden transparent dargestellt und die Zahlungsmethoden sind 
              optimal für deutsche Kunden angepasst. Unser Team überprüft regelmäßig die Qualität der 
              gelisteten Verkäufer und stellt sicher, dass nur vertrauenswürdige Quellen in unserem 
              <strong> OOPBuy Spreadsheet</strong> erscheinen.
            </p>

            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 mt-10 mb-4">
              Für wen ist das Spreadsheet geeignet?
            </h3>

            <p>
              Das <strong>OOPBuy Spreadsheet</strong> richtet sich an modebewusste Käufer in Deutschland, 
              die Wert auf Qualität und faire Preise legen. Ob du nach limitierten Sneakern, 
              hochwertigen Designerpieces oder einfach nach Basics für den Alltag suchst - unser 
              Spreadsheet bietet dir die perfekte Übersicht. Auch Einsteiger finden bei uns einen 
              einfachen Zugang zum internationalen Mode-Shopping.
            </p>

            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 mt-10 mb-4">
              Sicherheit und Vertrauen
            </h3>

            <p>
              Sicherheit steht bei uns an erster Stelle. Das <strong>OOPBuy Spreadsheet</strong> 
              arbeitet ausschließlich mit verifizierten Verkäufern zusammen und bietet umfassende 
              Buyer Protection. Jeder Kauf wird durch unser Qualitätskontrollsystem überprüft, bevor 
              die Ware nach Deutschland versendet wird. So stellen wir sicher, dass du immer die 
              beste Qualität zu fairen Preisen erhältst.
            </p>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/artikel/oopbuy-spreadsheet-ratgeber"
              className="inline-flex items-center px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-all duration-300 font-[family-name:var(--font-label)]"
            >
              Vollständigen Ratgeber Lesen
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors font-[family-name:var(--font-label)]"
            >
              oopbuy spreadsheet
            </a>
          </div>
        </article>
      </div>
    </section>
  );
}